var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7723 7.59092C12.5601 7.37878 12.3026 7.27279 11.9995 7.27279H11.636V5.09085C11.636 3.69693 11.1362 2.50007 10.1361 1.50007C9.13617 0.500022 7.93942 0 6.54531 0C5.15123 0 3.95425 0.500022 2.95436 1.50003C1.95432 2.50007 1.45446 3.69689 1.45446 5.09085V7.27279H1.09087C0.787944 7.27279 0.530311 7.37878 0.318171 7.59092C0.10603 7.8029 0 8.06054 0 8.36374V14.9091C0 15.2121 0.10607 15.4698 0.318171 15.6819C0.530311 15.8939 0.787944 16 1.09087 16H11.9997C12.3029 16 12.5603 15.894 12.7726 15.6819C12.9845 15.4698 13.0907 15.2121 13.0907 14.9091V8.36362C13.0909 8.06066 12.9845 7.80306 12.7723 7.59092ZM9.45434 7.27279H3.63628V5.09085C3.63628 4.28786 3.92042 3.60221 4.48858 3.03412C5.05682 2.46596 5.74236 2.18194 6.54543 2.18194C7.34857 2.18194 8.03395 2.46592 8.60223 3.03412C9.17023 3.60217 9.45434 4.28786 9.45434 5.09085V7.27279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.1fc13f7f2011f0b8f0851cafd33cda19.svg";
export { ForwardRef as ReactComponent };